module.exports = __webpack_public_path__ + "img/logo.fe1961a2.svg";